import React from "react";
import styles from "./DashboardMockup.module.css";

/** Mockup ilustrativo del panel de EduData (sin datos reales). */
const BARS = [52, 70, 44, 86, 63, 78];

const DashboardMockup: React.FC = () => {
    return (
        <div className={styles.window} aria-hidden="true">
            <div className={styles.bar}>
                <span className={`${styles.dot} ${styles.red}`} />
                <span className={`${styles.dot} ${styles.yellow}`} />
                <span className={`${styles.dot} ${styles.green}`} />
                <span className={styles.url}>edudata.com.co</span>
            </div>

            <div className={styles.body}>
                <div className={styles.tiles}>
                    <div className={styles.tile}>
                        <span className={styles.tileValue}>412</span>
                        <span className={styles.tileLabel}>Puntaje global</span>
                    </div>
                    <div className={styles.tile}>
                        <span className={styles.tileValue}>87%</span>
                        <span className={styles.tileLabel}>Percentil</span>
                    </div>
                    <div className={styles.tile}>
                        <span className={styles.tileValue}>5</span>
                        <span className={styles.tileLabel}>Áreas</span>
                    </div>
                </div>

                <div className={styles.chartCard}>
                    <div className={styles.chartHeader}>
                        <span className={styles.chartTitle}>Desempeño por área</span>
                        <span className={styles.chartLegend} />
                    </div>
                    <div className={styles.chart}>
                        {BARS.map((h, i) => (
                            <span
                                key={i}
                                className={styles.barCol}
                                style={
                                    {
                                        "--h": `${h}%`,
                                        "--d": `${0.4 + i * 0.1}s`,
                                    } as React.CSSProperties
                                }
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardMockup;
